module.exports = __webpack_public_path__ + "img/arc.1cf27895.png";